import Vue from 'vue'
import WorkerService from "../services/worker.service";

Vue.use(WorkerService)